<template>
  <div>

    <u-modal id="runBackup" title="Принудительно запустить бэкап" :isModalOpen="isModalOpen" @isModalOpen="isModalOpen = $event">
      <form @submit.prevent="runBackup">
        <div class="mb-3">
          <label for="backupSetting">Тип бэкапа</label>
          <select name="backupSetting" class="form-select" id="backupSetting" v-model="formData.backupSettingId">
            <option v-for="backupSetting in backupSettings"
                    :key="backupSetting.id"
                    :value="backupSetting.id"
            >{{backupSetting.name || `Настройка #${backupSetting.id}`}} [{{backupSetting.type}}]</option>
          </select>
        </div>

        <button type="submit" class="btn btn-success">Запустить</button>
      </form>
    </u-modal>
    <button type="submit" class="btn btn-success" @click="openForm">Запустить</button>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {useServiceStore} from "@/store/services";
import {useBackupStore} from "@/store/backups";
import {useBackupSettingStore} from "@/store/backup-settings";

const serviceStore = useServiceStore()
const service = computed(() => serviceStore.item)

const backupSettingStore = useBackupSettingStore()
const backupSettings = computed(() => backupSettingStore.items)
backupSettingStore.getList({serviceId: service.value.id})
    .then(() => {
      formData.value.backupSettingId = backupSettings.value[0].id
    })

const backupStore = useBackupStore()

const isModalOpen = ref(false)
const formData = ref({
  backupSettingId: null
})

function openForm() {
  isModalOpen.value = true
}

function runBackup() {
  backupStore.run({backupSettingId: formData.value.backupSettingId})
  isModalOpen.value = false
}

</script>
